import {useDispatch, useSelector} from 'react-redux';
import {userLoggedIn, hideLoginModal} from '~library/organisms/LoginModal/reducer';
import {LoginWrapper} from '~library/organisms/LoginModal/LoginWrapper';
import {useCurrentRoute} from '~/CreateFabricGreetingCard/navigation';

export const LoginModalReduxWrapper = () => {
  const dispatch = useDispatch();
  const {path} = useCurrentRoute();
  const showModal = useSelector((state) => state.loginModal.showLoginModal);

  if (path !== 'create') return null;
  return (
    <>
      <div
        className={
          !showModal ? 'login-modal-background bg-hidden' : 'login-modal-background bg-visible'
        }
      />
      <div className={`meganav-auth-slideout ${showModal ? 'open' : ''}`}>
        <LoginWrapper
          onSignupSuccess={(
            userId,
            fullName,
            subscriptionPlanName,
            email,
            avatarDisk,
            imgUrl,
            initials,
            firstName
          ) =>
            dispatch(
              userLoggedIn(
                userId,
                fullName,
                subscriptionPlanName,
                email,
                avatarDisk,
                imgUrl,
                initials,
                firstName
              )
            )
          }
          onLoginSuccess={(
            userId,
            fullName,
            subscriptionPlanName,
            email,
            avatarDisk,
            imgUrl,
            initials,
            firstName
          ) =>
            dispatch(
              userLoggedIn(
                userId,
                fullName,
                subscriptionPlanName,
                email,
                avatarDisk,
                imgUrl,
                initials,
                firstName
              )
            )
          }
          onCloser={() => dispatch(hideLoginModal())}
        />
      </div>
    </>
  );
};
